import UsableGifts from '../../components/pages/mypages/UsableGifts'
export default {
  components: { UsableGifts }
}
